import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" >
    <title>Icons/Social_YouTube</title>
    <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Font_Home_Default" transform="translate(-856.000000, -2076.000000)" fill="#999999" fill-rule="nonzero">
            <g id="Group-2" transform="translate(0.000000, 1926.000000)">
                <g id="Icons/Social_YouTube" transform="translate(856.000000, 150.000000)">
                    <path d="M13,0 C20.1797017,0 26,5.82029825 26,13 C26,20.1797017 20.1797017,26 13,26 C5.82029825,26 0,20.1797017 0,13 C0,5.82029825 5.82029825,0 13,0 Z M17.6748768,8.06896552 L7.42857143,8.06896552 C6.29816972,8.07228834 5.38262047,8.99134813 5.37931034,10.1260842 L5.37931034,10.1260842 L5.37931034,15.8739158 C5.38262047,17.0086519 6.29816972,17.9277117 7.42857143,17.9310345 L7.42857143,17.9310345 L17.6748768,17.9310345 C18.8052786,17.9277117 19.7208278,17.0086519 19.7241379,15.8739158 L19.7241379,15.8739158 L19.7241379,10.1260842 C19.7208278,8.99134813 18.8052786,8.07228834 17.6748768,8.06896552 L17.6748768,8.06896552 Z M11.0690235,10.7311191 L14.9475514,12.7458853 L11.0690235,14.7606516 L11.0690235,10.7311191 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
    );
};

export default React.memo(Youtube);
